import { IconMail } from "@tabler/icons-react"
import { type FC } from "react"

import { type InvitedStudent } from "@forento/core/models/user"
import { toDateTimeString } from "@forento/core/utilities/date"

import { toRelativeDateString } from "~/utilities/date"

const InvitedUsers: FC<{ invites: InvitedStudent[] }> = ({ invites }) => (
	<section aria-labelledby="pending-invites-heading" className="mt-10 space-y-4">
		<div>
			<h2 id="pending-invites-heading" className="text-lg font-semibold">
				Pending invites <span className="ml-1 text-gray-400">{invites.length}</span>
			</h2>
			<p className="mt-1 text-sm text-gray-500">
				People you have invited by email who haven’t created an account yet.
			</p>
		</div>
		<ul className="divide-component-border border-component-border divide-y overflow-hidden rounded-3xl border bg-white">
			{[...invites]
				.sort((a, b) => a.expireDate.getTime() - b.expireDate.getTime())
				.map(invite => (
					<li key={invite.email} className="flex flex-wrap items-center gap-x-4 gap-y-1 px-5 py-3.5 text-sm">
						<div className="flex min-w-0 flex-1 items-center gap-3">
							<IconMail className="size-4 shrink-0 text-gray-400" aria-hidden="true" />
							<span className="truncate font-medium">{invite.email}</span>
						</div>
						{invite.membershipTitle !== null && (
							<span className="border-primary/20 bg-primary/5 text-primary rounded-full border px-2.5 py-1 text-xs font-medium">
								{invite.membershipTitle}
							</span>
						)}
						<span className="text-gray-500" title={toDateTimeString(invite.expireDate)}>
							Expires {toRelativeDateString(invite.expireDate)}
						</span>
					</li>
				))}
		</ul>
	</section>
)

export default InvitedUsers
